import type { FilmTiming } from "./timeline";

/** Cat-only art direction and second-based pacing. Shared Fourier films retain their defaults. */
export const catTheme = {
  colors: {
    background: "#FFF8E9",
    trail: "#FF3E86",
    circle: "#1EAAB0",
    vector: "#FF6B4D",
    text: "#23304B",
    muted: "#8191A2",
    accent: "#FF6B4D",
  },
  timing: {
    intro: 0,
    stages: [2.3, 2.35, 2.6, 3.05],
    outro: 1.7,
    hold: 0.06,
    crossfade: 0.12,
    focusDelay: 0.08,
    focusDuration: 0.52,
  } satisfies FilmTiming,
} as const;

export const CAT_DURATION_SECONDS = Math.round((
  catTheme.timing.intro + catTheme.timing.stages.reduce((a, b) => a + b, 0) + catTheme.timing.outro
) * 1000) / 1000;
